<template>
  <div class="main">
    <div class="top_back">
      <DivTop />
    </div>
    <div class="w120">
      <div class="btns">
        <!-- <div> -->
          <!-- 导出 -->
        <!-- </div> -->
      </div>
      <div class="tables">
          <div>留言时间</div>
          <div>姓名</div>
          <div>联系电话</div>
          <div>留言内容</div>
      </div>
      <div class="tables_content">
        <div v-for="item in tableData" :key="item.id">
          <div>{{item.createtime}}</div>
          <div>{{item.name}}</div>
          <div>{{item.tel}}</div>
          <div>{{item.description}}</div>
        </div>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" @current-change="currenchange" :total="total" :page-size="data.num" :current-page="data.page" ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data(){
    return{
      data:{
        page:1,
        num:10
      },
      total:0,
      tableData:[]
    }
  },
  created(){
    this.getList()
  },
  methods:{
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    getList(){
      this.MethodPost('http://api.softykt.net/Leaveword/GetleaveWordList',qs.stringify(this.data)).then(res=>{
          if(res.data.recode=='666'){
              this.tableData = res.data.res.list
              this.total =  Number(res.data.res.paging.total_row)
          }
      })
    }
  }
}
</script>
<style scoped lang="less">
.main{
  width: 100%;
  background: #E5E5E5;
  height: 100vh;
  .top_back{
    width: 100%;
    position: relative;
    background: #001E3C;
    height: 7.2rem;
  }
  .btns{
    margin-top: 6.5rem;
    display: flex;
    justify-content: flex-end;
    >div{
      width: 10rem;
      height: 3rem;
      font-size: 1.6rem;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #0366ED;
      border-radius: 0.6rem;
    }
  }
  .tables{
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    >div{
      background: #0366ED;
      height: 3rem;
      color: #fff;
      font-size: 1.2rem;
      display: flex;
      align-items: center;
      padding: 0 2rem;
      box-sizing: border-box;
      &:nth-child(1){
        width: 19.8rem;
      }
      &:nth-child(2){
        margin-left: 0.1rem;
        width: 11rem;
      }
      &:nth-child(3){
        margin-left: 0.1rem;
        width: 16rem;
      }
      &:nth-child(4){
        flex: 1;
        margin-left: 0.1rem;
      }

    }
  }
  .tables_content{
    >div{
      display: flex;
      &:nth-child(odd){
        background: #F6F9FC;
      }
      &:nth-child(even){
        background: #FFFFFF;
      }
      >div{
        color: #000000;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        padding: 0.7rem 2rem;
        box-sizing: border-box;
        &:nth-child(1){
          width: 19.8rem;
        }
        &:nth-child(2){
          margin-left: 0.1rem;
          width: 11rem;
          white-space:normal;word-break:break-all;word-wrap:break-word;
        }
        &:nth-child(3){
          margin-left: 0.1rem;
          width: 16rem;
          white-space:normal;word-break:break-all;word-wrap:break-word;
        }
        &:nth-child(4){
          white-space:normal;word-break:break-all;word-wrap:break-word;
          flex: 1;
          margin-left: 0.1rem;
        }
      }
    }
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
</style>